import { Mountain, Waves, Flag } from 'lucide-react';

/**
 * The three circuit boards shown on the leaderboard.
 *
 * Kept in one place because both the public /leaderboard page and the
 * /venue/leaderboard display render them, and the two must never drift apart.
 */
export const TRACK_BOARDS = [
  {
    kicker: 'THE GREEN HELL',
    title: 'Nürburgring Nordschleife',
    subtitle: 'The most demanding circuit in the world',
    icon: Mountain,
    trackKey: 'nordschleife',
    keywords: ['nord', 'nürburgring', 'nurburgring'],
    flag: 'DE',
    accent: '#34d399',
    accentText: 'text-emerald-300',
    borderClass: 'border-emerald-900/40',
    bandClass: 'from-[#0a120e] via-[#0c1a12] to-[#0a120e]',
    ambient: 'radial-gradient(120% 80% at 50% -10%, rgba(16,185,129,0.18) 0%, rgba(8,20,12,0) 55%)',
  },
  {
    kicker: 'ARDENNES · BELGIUM',
    title: 'Spa-Francorchamps',
    subtitle: 'Eau Rouge, Raidillon & the longest lap on the calendar',
    icon: Waves,
    trackKey: 'spa',
    keywords: ['spa', 'francorchamps'],
    flag: 'BE',
    accent: '#facc15',
    accentText: 'text-amber-400',
    borderClass: 'border-amber-900/40',
    bandClass: 'from-[#0d0c08] via-[#161308] to-[#0d0c08]',
    ambient: 'radial-gradient(120% 80% at 50% -10%, rgba(250,204,21,0.16) 0%, rgba(20,16,8,0) 55%)',
  },
  {
    kicker: 'NORTHAMPTONSHIRE · UK',
    title: 'Silverstone',
    subtitle: 'Home of British Motor Racing',
    icon: Flag,
    trackKey: 'silverstone',
    keywords: ['silverstone'],
    flag: 'GB',
    accent: '#cbd5e1',
    accentText: 'text-slate-300',
    borderClass: 'border-slate-700/40',
    bandClass: 'from-[#0a0b0e] via-[#0f1217] to-[#0a0b0e]',
    ambient: 'radial-gradient(120% 80% at 50% -10%, rgba(148,163,184,0.15) 0%, rgba(10,11,14,0) 55%)',
  },
];

/**
 * Look up a board by its trackKey (e.g. 'spa'). Returns null for an unknown or
 * missing key, so a mistyped URL still produces a working rotating display.
 */
export function trackBoardByKey(key) {
  if (!key) return null;
  return TRACK_BOARDS.find((b) => b.trackKey === key) || null;
}